import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { useContent } from "@/content";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const ctrl = animate(0, value, { duration: 1.6, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => ctrl.stop();
  }, [inView, value]);

  return (
    <span ref={ref} className="tabular-nums">
      {n}
      {suffix}
    </span>
  );
};

export const Stats = () => {
  const { STATS } = useContent();
  return (
  <section className="relative bg-[#0B1528] py-16 md:py-20 overflow-hidden" data-testid="stats-section">
    <div className="absolute inset-0 hero-grid-dark" />
    <div className="glow-amber-light absolute -top-32 right-0 h-96 w-96 rounded-full" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8 grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="relative pl-5 border-l border-amber-400/40"
          data-testid={`stat-item-${i}`}
        >
          <p className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white">
            <Counter value={s.value} suffix={s.suffix} />
          </p>
          <p className="mt-2 text-sm text-slate-400 leading-snug">{s.label}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
};
